export const LOGIN_STATE="loginState";
export const LOGOUT_STATE = 'LOGOUT_STATE';